import { render, staticRenderFns } from "./DFRPage.vue?vue&type=template&id=a2ff5568"
import script from "./DFRPage.vue?vue&type=script&lang=js"
export * from "./DFRPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports